/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconClose from '@telus-uds/palette-koodo/build/rn/icons/Close'
const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: {
        footnoteBodyPaddingBottom: 32,
        footnoteBodyPaddingLeft: 16,
        footnoteBodyPaddingRight: 16,
        footnoteBodyPaddingTop: 0,
        footnoteHeaderPaddingBottom: 16,
        footnoteHeaderPaddingLeft: 16,
        footnoteHeaderPaddingRight: 4,
        footnoteHeaderPaddingTop: 16
      }
    },
    {
      if: { viewport: [ 'md', 'lg', 'xl' ] },
      tokens: {
        footnoteBodyPaddingBottom: 40,
        footnoteBodyPaddingLeft: 16,
        footnoteBodyPaddingRight: 16,
        footnoteBodyPaddingTop: 0,
        footnoteHeaderPaddingBottom: 24,
        footnoteHeaderPaddingLeft: 16,
        footnoteHeaderPaddingRight: 4,
        footnoteHeaderPaddingTop: 24
      }
    }
  ],
  tokens: {
    closeButtonBackgroundColor: '#ffffff',
    closeButtonBorderColor: '#000000',
    closeButtonBorderSize: 0,
    closeButtonHeight: 16,
    closeButtonIconSize: 16,
    closeButtonMarginBottom: 4,
    closeButtonMarginLeft: 4,
    closeButtonMarginRight: 12,
    closeButtonMarginTop: 4,
    closeButtonWidth: 16,
    closeIcon: PaletteIconClose,
    footnoteBackground: '#ffffff',
    footnoteBodyBackground: '#ffffff',
    footnoteBodyPaddingBottom: 40,
    footnoteBodyPaddingLeft: 16,
    footnoteBodyPaddingRight: 16,
    footnoteBodyPaddingTop: 0,
    footnoteBorderColorMd: '#c9c8c8',
    footnoteBorderTopSizeMd: 1,
    footnoteHeaderPaddingBottom: 24,
    footnoteHeaderPaddingLeft: 16,
    footnoteHeaderPaddingRight: 4,
    footnoteHeaderPaddingTop: 24,
    headerFontName: 'StagSans',
    headerFontSize: 16,
    headerFontWeight: '700',
    headerLineHeight: 1.25,
    headerMargin: 16,
    listItemColor: '#000000',
    listItemFontName: 'StagSans',
    listItemFontSize: 14,
    listItemFontWeight: '400',
    listItemLineHeight: 1.42857142857,
    listItemMarkerFontSize: 14,
    listItemMarkerLineHeight: 1.45,
    listItemPaddingLeft: 8,
    listPaddingLeft: 32
  }
}
export default theme
